import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} GGC-SD</p>
        </footer> 
    );
};

export default Footer;